import { appName } from "@core/schema/names/appName.js";

export function createTitle(title?: string): string {
	if (!title) {
		return appName;
	} else {
		return title;
	}
}
